import { Link } from '@tanstack/react-router';

import { cn } from '@apps/web/lib/utils';

type AgentTraceView = 'conversations' | 'ephemeral' | 'prompts';

const VIEW_LINK_CLASS_NAME =
    'rounded-md px-3 py-1.5 text-sm font-medium transition-colors';

export function AgentTraceViewTabs({
    activeView,
}: {
    readonly activeView: AgentTraceView;
}) {
    return (
        <nav
            aria-label="Agent trace views"
            className="bg-muted flex w-fit items-center rounded-lg p-1"
        >
            <Link
                to="/admin/agent-traces"
                aria-current={
                    activeView === 'conversations' ? 'page' : undefined
                }
                className={cn(
                    VIEW_LINK_CLASS_NAME,
                    activeView === 'conversations'
                        ? 'bg-background text-foreground shadow-sm'
                        : 'text-muted-foreground hover:text-foreground',
                )}
            >
                Conversations
            </Link>
            <Link
                to="/admin/agent-traces/ephemeral"
                aria-current={activeView === 'ephemeral' ? 'page' : undefined}
                className={cn(
                    VIEW_LINK_CLASS_NAME,
                    activeView === 'ephemeral'
                        ? 'bg-background text-foreground shadow-sm'
                        : 'text-muted-foreground hover:text-foreground',
                )}
            >
                Ephemeral
            </Link>
            <Link
                to="/admin/agent-traces/prompts"
                aria-current={activeView === 'prompts' ? 'page' : undefined}
                className={cn(
                    VIEW_LINK_CLASS_NAME,
                    activeView === 'prompts'
                        ? 'bg-background text-foreground shadow-sm'
                        : 'text-muted-foreground hover:text-foreground',
                )}
            >
                Prompts
            </Link>
        </nav>
    );
}
